import { FC, useState, useEffect, ChangeEvent, useMemo, useCallback } from 'react';
import { useField, Field, Formik, FieldProps } from 'formik';
import { insertObjProperty } from '../../utils/objectAndArray';
import Button from '../GroupActions/Button';
import FilterInput from '../GroupActions/FilterInput';
import AddNewForm from './AddNew';
import SingleItem from './SingleItem';
import { makeCSSStr } from '../../utils/css';

export interface TokenFormProps {
  label: string;
  name: string;
  valueList: any;
}

const GroupField: FC<TokenFormProps> = ({ label, valueList, ...props }) => {
  // @ts-ignore
  const [field, meta, helpers] = useField(props);
  const [showGroup, setShowGroup] = useState(null);
  const options = useMemo(
    () =>
      Object.values(valueList).reduce((acc: any, curr: any) => {
        return acc.concat(Object.entries(curr).map(([k, v]) => ({ label: k, value: `var(${k})` })));
      }, []),
    [field.value]
  );

  const handlers = useMemo(
    () => ({
      add(key: string, value: any) {
        const updated = insertObjProperty(field.value, key, value);
        helpers.setValue(updated);
      },
      delete(key: string) {
        const updated = { ...field.value };
        delete updated[key];
        helpers.setValue(updated);
      },
      sort() {
        const sorted = Object.keys(field.value)
          .sort((a, b) => (a < b ? -1 : 1))
          .reduce((sorted, key) => {
            return { ...sorted, [key]: field.value[key] };
          }, {});
        helpers.setValue(sorted);
      },
      filter(param: React.ChangeEvent<HTMLInputElement>, type = 'both') {
        const searchTerm = param?.target?.value;
        const filteredItems = Object.entries(field.value).reduce((filtered, [token_name, token_value]: any[]) => {
          if (type === 'both' && (token_name.includes(searchTerm) || token_value.includes(searchTerm))) {
            return { ...filtered, [token_name]: token_value };
          }
          if (type === 'name' && token_name.includes(searchTerm)) {
            return { ...filtered, [token_name]: token_value };
          }
          if (type === 'value' && token_value.includes(searchTerm)) {
            return { ...filtered, [token_name]: token_value };
          }
          return filtered;
        }, {});
        // @ts-ignore
        setShowGroup(filteredItems);
      },
      update(value: any, k: string) {
        const updated = { ...field.value };
        updated[k] = value;
        helpers.setValue(updated);
      },
    }),
    [field.value]
  );

  useEffect(() => {
    const d = document.getElementById(props.name);
    if (d) {
      document.head.removeChild(d);
    }
    // @TODO: Find better way to dynamically assign fonts
    document.head.insertAdjacentHTML('beforeend', `<style id=${props.name}>:root {${makeCSSStr(field.value)}}</style>`);
  }, [field.value]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <AddNewForm onClick={handlers.add} type={props.name} options={options} />
        </div>
        <div style={{ display: 'flex' }}>
          <FilterInput
            handleFilterInput={handlers.filter}
            showReset={!!showGroup}
            handleReset={() => setShowGroup(null)}
          />
          <Button
            onClick={handlers.sort}
            label='SORT'
            iconAlignment='right'
            theme='primary'
            variant='rounded'
            size='compressed'
          >
            Sort
          </Button>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>Token Name</th>
            <th>Value</th>
            <th>Sample</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(showGroup || field.value).map(([k, v]: any[]) => (
            <SingleItem
              key={k}
              k={k}
              v={v}
              options={options}
              onChange={handlers.update}
              onDelete={handlers.delete}
              tokenType={props.name}
            />
          ))}
        </tbody>
      </table>
    </>
  );
};

export default GroupField;

{
  /* Version that updates on input change */
}
{
  /* <Formik
            initialValues={{ token_name: k, value: v }}
            onSubmit={() => console.log(v)}
          >
            {({ values }) => (
              <>
                <Field type="text" name="token_name" />
                {v.includes("var") ? (
                  <Field as="select" name={`${field.name}[${k}]`}>
                    {options.map((item) => (
                      <option value={item}>{item}</option>
                    ))}
                  </Field>
                ) : (
                  <Field
                    type="text"
                    name="value"
                    value={v}
                    onChange={(event: any) =>
                      handleInnerValue(event.target.value, k)
                    }
                  />
                )}
              </>
            )}
          </Formik> */
}
